import aws4 from 'aws4';
import jwtDecode from 'jwt-decode';
import axios from 'axios';

let axiosInterceptor;
const domain = 'lct.auth.eu-west-1.amazoncognito.com';
const clientId = '5an5nogdo4u7tk8659uhjv8h4d';
const IdentityPoolId = 'eu-west-1:0fb93895-5f71-4791-be25-032a13fd8eac';

export default {
  authenticateCognito() {
    const type = 'code';
    const scope = 'openid profile';
    const callback = `${window.location.protocol}//${window.location.host}`;
    const verification = Math.random().toString(36).substring(7);
    window.location.href = `https://${domain}/login?response_type=${type}&client_id=${clientId}&redirect_uri=${callback}&state=${verification}&scope=${scope}`;
  },
  authorizationCognito(provider) {
    const type = 'code';
    const identityProvider = provider;
    const scope = 'openid profile';
    const callback = `${window.location.protocol}//${window.location.host}`;
    const verification = Math.random().toString(36).substring(7);
    window.location.href = `https://${domain}/oauth2/authorize?response_type=${type}&client_id=${clientId}&redirect_uri=${callback}&state=${verification}&scope=${scope}&identity_provider=${identityProvider}`;
  },
  tokenCognito(authorizationCode) {
    const grandType = 'authorization_code';
    const callback = `${window.location.protocol}//${window.location.host}`;
    return axios.post(`https://${domain}/oauth2/token`,
      `grant_type=${grandType}&code=${authorizationCode}&client_id=${clientId}&redirect_uri=${callback}`,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    ).then((response) => {
      const { refresh_token: rt, expires_in: expiresIn, id_token: idToken } = response.data;
      sessionStorage.setItem('refresh_token', rt);
      setTimeout(() => this.refreshCognito(rt), expiresIn * 1000);
      return idToken;
    }).then(idToken => this.getIAMToken(idToken));
  },
  refreshCognito(refreshToken) {
    const grandType = 'refresh_token';
    const callback = `${window.location.protocol}//${window.location.host}`;
    return axios.post(`https://${domain}/oauth2/token`,
      `grant_type=${grandType}&refresh_token=${refreshToken}&client_id=${clientId}&redirect_uri=${callback}`,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    ).then((response) => {
      const { expires_in: expiresIn, id_token: idToken } = response.data;
      setTimeout(() => this.refreshCognito(refreshToken), expiresIn * 1000);
      return idToken;
    }).then(idToken => this.getIAMToken(idToken));
  },
  getIAMIdentityId(idToken) {
    return axios.post('https://cognito-identity.eu-west-1.amazonaws.com/', {
      AccountId: '537045940424',
      IdentityPoolId,
      Logins: {
        'cognito-idp.eu-west-1.amazonaws.com/eu-west-1_6UuF9lS3P': idToken,
      },
    }, {
      headers: {
        'Content-Type': 'application/x-amz-json-1.1',
        'X-AMZ-TARGET': 'com.amazonaws.cognito.identity.model.AWSCognitoIdentityService.GetId',
      },
    }).then(response => response.data.IdentityId);
  },

  getIAMToken(idToken) {
    return this.getIAMIdentityId(idToken).then((identityId) => {
      const user = jwtDecode(idToken);
      return axios.post('https://cognito-identity.eu-west-1.amazonaws.com/', {
        IdentityId: identityId,
        CustomRoleArn: user['cognito:preferred_role'],
        Logins: {
          'cognito-idp.eu-west-1.amazonaws.com/eu-west-1_6UuF9lS3P': idToken,
        },
      }, {
        headers: {
          'Content-Type': 'application/x-amz-json-1.1',
          'X-AMZ-TARGET': 'com.amazonaws.cognito.identity.model.AWSCognitoIdentityService.GetCredentialsForIdentity',
        },
      }).then((response) => {
        sessionStorage.setItem('AccessKeyId', response.data.Credentials.AccessKeyId);
        sessionStorage.setItem('SessionToken', response.data.Credentials.SessionToken);
        sessionStorage.setItem('SecretKey', response.data.Credentials.SecretKey);
        sessionStorage.setItem('sub', user.sub);
        sessionStorage.setItem('exp', user.exp);
        const userRole = user['cognito:preferred_role'];
        const existingRoles = ['arn:aws:iam::537045940424:role/Cognito_LCT_ADMIN_USERAuth_Role', 'arn:aws:iam::537045940424:role/Cognito_LCT_PREMIUM_USERS_Role', 'arn:aws:iam::537045940424:role/Cognito_LCT_CONNECTED_USERSAuth_Role'];
        const expliciteRoles = ['admin', 'premium', 'user'];
        const role = expliciteRoles[existingRoles.indexOf(userRole)];
        sessionStorage.setItem('userrole', role);
        this.addInterceptor();
      });
    });
  },
  addInterceptor() {
    if (typeof axiosInterceptor === 'number' && axiosInterceptor >= 0) {
      axios.interceptors.request.eject(axiosInterceptor);
    }
    axiosInterceptor = axios.interceptors.request.use((config) => {
      if (config.url.startsWith(`${process.env.LCT_API_URL}/`)) {
        if (!this.isTokenValid()) {
          this.logout();
          throw new axios.Cancel('No token, logout.');
        }

        const ops = {
          service: 'execute-api',
          region: 'eu-west-1',
          host: process.env.LCT_API_HOST,
          method: config.method.toUpperCase(),
          path: process.env.LCT_API_PATH + config.url.substr(`${process.env.LCT_API_URL}`.length),
          body: JSON.stringify(config.data),
        };
        if (ops.body) {
          const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
          ops.headers = {
            'Content-Type': isChrome ? 'application/json;charset=UTF-8' : 'application/json;charset=utf-8',
          };
        }
        aws4.sign(ops, {
          secretAccessKey: sessionStorage.getItem('SecretKey'),
          accessKeyId: sessionStorage.getItem('AccessKeyId'),
          sessionToken: sessionStorage.getItem('SessionToken'),
        });
        /* eslint-disable no-param-reassign */
        config.headers.common.Authorization = ops.headers.Authorization;
        config.headers.common['X-Amz-Security-Token'] = ops.headers['X-Amz-Security-Token'];
        config.headers.common['X-Amz-Date'] = ops.headers['X-Amz-Date'];
      }
      return config;
    }, (error => Promise.reject(error)));
  },
  logout() {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('exp');
    sessionStorage.removeItem('AccessKeyId');
    sessionStorage.removeItem('SessionToken');
    sessionStorage.removeItem('SecretKey');
    sessionStorage.removeItem('sub');
    sessionStorage.removeItem('userrole');
    sessionStorage.removeItem('refresh_token');
    axios.interceptors.request.eject(axiosInterceptor);
  },
  isTokenValid() {
    return sessionStorage.getItem('exp') && (Date.now() / 1000) < sessionStorage.getItem('exp');
  },
  isAuthenticated() {
    return sessionStorage.getItem('SessionToken');
  },
  isPremium() {
    return sessionStorage.getItem('userrole') === 'premium';
  },
  isPremiumOrAdmin() {
    return sessionStorage.getItem('userrole') === 'premium' || sessionStorage.getItem('userrole') === 'admin';
  },
  setConnectedUser(user) {
    sessionStorage.setItem('user', JSON.stringify(user));
  },
  getConnectedUser() {
    return JSON.parse(sessionStorage.getItem('user'));
  },
  init() {
    if (this.isAuthenticated()) {
      if (!this.isTokenValid()) {
        this.logout();
      } else {
        this.addInterceptor();
        const refreshToken = sessionStorage.getItem('refresh_token');
        if (refreshToken) {
          const expire = sessionStorage.getItem('exp') * 1000;
          setTimeout(() => this.refreshCognito(refreshToken), expire - Date.now());
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/iam.js